import type { Flag } from '#utils/flags/records/Flag';
import type { GenerateActionType } from '#utils/reduxUtils';
import type { Role } from '#utils/roleUtils';
import type { ResourceKind } from '#utils/saveButtonUtils';
import type { Segment } from '#utils/segment/records/Segment';
import type { User } from '#utils/userUtils';

export const editChangeDescription = (
  resourceKind: ResourceKind,
  resource: Flag | User | Segment | Role,
  comment: string,
) =>
  ({
    type: 'comments/EDIT_CHANGE_DESCRIPTION',
    resourceKind,
    resource,
    comment,
  }) as const;

const CommentsActionCreators = {
  editChangeDescription,
};

export type CommentsAction = GenerateActionType<typeof CommentsActionCreators>;
